import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

import { SCREEN } from '../../assets/styles/constants';
import { flex } from '../../assets/styles/flex-grid';

export const IndexPageWrapper = styled.div`
	${props => `background-image:
			${props.images.map(image => `url(${image})`)}`};
	background-size: 20%, 35%, 20%, 12%, contain;
    background-position: 30% 75%, top right, 77% 75%, 16% 72%,left top;
    background-repeat: no-repeat, no-repeat, no-repeat, no-repeat, no-repeat;
	min-height: 700px;
	${SCREEN.SMALL}{
		background-image: url(${props => props.mobileImage}), url(${props => props.cloudes});
		background-position: 0% 93%, right top;
		background-size: contain, 70%;
	}
	@media (min-height: 900px){
		background-position: 30% 90%, top right, 77% 90%, 16% 72%, left top;
	}
	padding: 0 20px;
`;

export const Title = styled.h1`
	font-size: 32px;
	text-transform: uppercase;
	letter-spacing: 1.5px;
	${SCREEN.SMALL}{
		font-size: 16px
	}
`;
export const CenterContentWrapper = styled.div`
	${flex};
	justify-content: center;
	align-items: center;
	flex-direction: column;
	position: relative;
	max-width: 600px;
	margin: 0 auto;
	text-align: center;
`;
export const StyledP = styled.p`
	font-size: 20px;
	${SCREEN.SMALL}{
		font-size: 16px;
	}
`;
export const PrimaryButton = styled.button`
	cursor:pointer;
	${flex};
	justify-content: center;
	align-items: center;
	min-width: 189px;
	background: ${props => props.mainColor};
	background: ${props => `linear-gradient(0deg, ${props.secondaryColor} 0%, ${props.mainColor} 100%)`};
	padding: 25px 0;
	line-height: 1.4px;
	font-size: 18px;
	border-radius: 4px;
	color: white;

	&:hover{
		opacity: .7;
	}
	${props => props.invert && css`
		background: white;
		border: 1px solid ${props.mainColor};
		color: ${props.mainColor};
	`}
`;

PrimaryButton.propTypes = {
	mainColor: PropTypes.string,
	secondaryColor: PropTypes.string,
	invert: PropTypes.bool,
};

PrimaryButton.defaultProps = {
	mainColor: 'rgba(147,228,182,1)',
	secondaryColor: 'rgba(104,211,151,1)',
	invert: false,
};
export const ButtonsWrapper = styled.div`
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 100%;
	${SCREEN.SMALL}{
		flex-direction: column;
		& > button {
		width:100%;
		margin-top: 15px;
		:first-child{
			margin-top: 0;
		}
	}
`;
